
import { defineComponent, PropType } from 'vue';
import { B2CResetPasswordTileModel } from '@/types/B2CcontentServerContract';
import ProfileResetPassword from '@/b2c/profile/ui/ProfileResetPassword.vue';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';

export default defineComponent({
    name: 'B2CResetPasswordTile',
    components: { BlockMaxWidthHandler, ProfileResetPassword },
    props: {
        content: {
            type: Object as PropType<B2CResetPasswordTileModel>,
            required: true,
        },
    },
});
